// extracted by mini-css-extract-plugin
export default {"confirmModal":"Void_confirmModal__En3-2","confirmModalInfo":"Void_confirmModalInfo__ai-4w","confirmModalCTA":"Void_confirmModalCTA__ovsPH","voidText":"Void_voidText__PaZcK"};